import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component ensures that when navigating to a new route,
 * the page scrolls to the top automatically.
 * 
 * This prevents the common issue where navigating to a new page
 * starts at the middle or bottom of the previous page's scroll position.
 * 
 * Optimized for both desktop and mobile browsers.
 */
// Routes that manage their own scroll position
const SCROLL_PRESERVE_ROUTES = ["/vacatures", "/kandidaten"];

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip scroll-to-top for routes that preserve scroll position
    if (SCROLL_PRESERVE_ROUTES.includes(pathname)) {
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};
